// extracted by mini-css-extract-plugin
export default {"productDescription":"w--z","featuredDescription":"x--z","description":"y--z","more":"z--z","descriptionSku":"A--z"};